$(document).ready(function () {
   $('.pagination > .page').each(function (index, element) {
       if ($(element).children('a').length > 0) {
           $(element).css('padding', '8px 0');
       }
   });
});